import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, User } from 'lucide-react';
import { ThemeToggle } from '@/components/ThemeToggle';
import logoDobraImg from '@/assets/logo-dobra.gif';

export default function ResetPassword() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-primary/10 via-background to-secondary/10 p-4 relative">
      {/* Toggle de Tema - canto superior direito */}
      <div className="absolute top-4 right-4">
        <ThemeToggle variant="icon" />
      </div>
      
      <div className="w-full max-w-md space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <img 
            src={logoDobraImg} 
            alt="Dobra Camisetas Personalizadas" 
            className="h-20 w-auto object-contain opacity-95 hover:opacity-100 transition-opacity drop-shadow-lg"
          />
        </div>
        
        {/* Card Informativo */}
        <Card className="w-full">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl font-bold text-center">
              Recuperar Senha
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="text-center space-y-3">
              <p className="text-muted-foreground">
                Para recuperar sua senha, entre em contato com o administrador do sistema.
              </p>
              <div className="p-4 bg-muted rounded-lg flex items-center gap-3">
                <User className="h-8 w-8 text-primary shrink-0" />
                <div className="text-left">
                  <p className="font-medium">Procure o Walter</p>
                  <p className="text-sm text-muted-foreground">
                    Solicite a redefinição da sua senha diretamente com ele.
                  </p>
                </div>
              </div>
            </div>

            <Button
              variant="ghost"
              className="w-full"
              onClick={() => navigate('/auth')}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar para Login
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
